import { Paper, Link } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import moment from 'moment'
import useFetch from './api/api'
import config from "./common/Config";

function OperationsLogs() {

	const [operationLogs, setOperationLogs] = useState()
	const privateFetch = useFetch();

	let options = {
		method : 'GET',
		headers : {
			'content-type' : 'application/json; charset=utf-8',
		}
	}

	useEffect(() => {
		privateFetch(config.apiUrl +"/api/operations", options)
		.then((data) => data.json())
		.then((data) => setOperationLogs(data))
	},[])	


    const columns = [
        { 
			field : 'date', 
			headerName : 'Data',
			renderCell: (cellValues) => <Link href={`/operationLogs/${cellValues.row.date}`}>{moment(cellValues.row.date).format("DD/MM/YYYY")}</Link>,
			width : 100
		},
        { field : 'total', headerName : 'Total', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'acoes_tot', headerName : 'Ações (Total)', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true, width : 120},
        { field : 'acoes_suc', headerName : 'Sucessos', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'acoes_err', headerName : 'Erros', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'stocks_tot', headerName : 'Stocks (Total)', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true, width : 120},
        { field : 'stocks_suc', headerName : 'Sucessos', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'stocks_err', headerName : 'Erros', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'dividendos_br_tot', headerName : 'Dividendos BR', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true, width : 120},
        { field : 'dividendos_br_suc', headerName : 'Sucessos', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'dividendos_br_err', headerName : 'Erros', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'dividendos_us_tot', headerName : 'Dividendos US', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true, width : 120},
        { field : 'dividendos_us_suc', headerName : 'Sucessos', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'dividendos_us_err', headerName : 'Erros', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
	]

	if (operationLogs === undefined)  {
		return <h1>loading...</h1>;
	}
	return(
		<Paper sx={{marginLeft: 2, marginRight : 4}}>

			<DataGrid
				getRowId={(row) => row.date} 
				rows={operationLogs}
				columns={columns}
				initialState={{
					pagination: { paginationModel: { pageSize: 20 } },
				}}
				pageSizeOptions={[5, 10, 20]}
				rowHeight={30}
			/>
			</Paper>
	)
}

export default OperationsLogs